import React from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const OcCustomPickerIcon = () => {

  const theme = useTheme();

  return (
    <Box
      sx={{
        color: theme.palette.gray80.main,
        borderRadius: "50%",
        padding: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "16px",
        height: "16px",
      }}
    >
      <AccessTimeIcon />
    </Box>
  );
};

export default OcCustomPickerIcon;
